import { Component, Input } from '@angular/core';
import {
  Chart,
  ChartOptions,
  ChartTypeRegistry,
  registerables,
} from 'chart.js';
import { Observable } from 'rxjs';
Chart.register(...registerables);

@Component({
  selector: 'app-chart-component',
  templateUrl: './chart-component.component.html',
  styleUrls: ['./chart-component.component.scss'],
})
export class ChartComponentComponent {
  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() chartType!: keyof ChartTypeRegistry;
  @Input() legend = true;
  @Input() labels?: string[];
  @Input() options?: ChartOptions;
  @Input() isLoading = true;
  @Input() data$?: Observable<any>;
  @Input() datasets$?: Observable<any>;

  constructor() {}
}
